<template>
  <el-table-column
    prop="responsible_user_deadline"
    sortable="custom"
    label="Felelős határideje"
    show-overflow-tooltip
    width="200px"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.responsible_user_deadline">{{ scope.row.responsible_user_deadline | date }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'responsible_user_deadline',
  };
</script>
